import RemoteCollection from "#root/utility/remote-collection";
import { z } from "zod";

export const DeploymentListItemSchema = z
  .object({
    id: z.number(),
    name: z.string().nullish(),
    status: z.string().nullish(),
    accountId: z.number().nullish(),
    lastUsage: z.string().nullish(),
    firstUsage: z.string().nullish(),
  })
  .loose();

export type DeploymentListItem = z.output<typeof DeploymentListItemSchema>;

export function getDeploymentCollectionForAccount(accountId: string) {
  return new RemoteCollection(`/api/account/${accountId}/deployment`, DeploymentListItemSchema);
}
